import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Collapse,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveMedicine } from './hooks/useSaveMedicine';

export default function MedicineFormModal({ open, onClose, onSave, medicine }) {
  const navigate = useNavigate();
  const { save: saveMedicine } = useSaveMedicine();
  const [formDescription, setFormDescription] = useState('');
  const [formDosage, setFormDosage] = useState('');
  const [formControlled, setFormControlled] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setFormDescription(medicine?.description ?? '');
      setFormDosage(medicine?.dosage ?? '');
      setFormControlled(medicine?.controlled ?? false);
      setError('');
    }
  }, [open, medicine]);

  const save = () => {
    if (!formDescription.trim()) return;

    const payload = {
      description: formDescription,
      dosage: formDosage,
      controlled: formControlled,
    };
    saveMedicine(medicine ? medicine.id : null, payload)
      .then(() => {
        onSave(payload);
        onClose();
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/expired-session');
        } else {
          setError(err.response?.data ?? 'Erro ao salvar medicamento.');
        }
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {medicine ? 'Editar Medicamento' : 'Novo Medicamento'}
      </DialogTitle>
      <DialogContent>
        <Collapse in={!!error} sx={{ mb: 1 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {error}
          </Alert>
        </Collapse>
        <TextField
          autoFocus
          label="Nome"
          fullWidth
          value={formDescription}
          onChange={(e) => setFormDescription(e.target.value)}
          sx={{ mt: 1 }}
        />
        <TextField
          label="Posologia Padrão"
          fullWidth
          multiline
          rows={3}
          value={formDosage}
          onChange={(e) => setFormDosage(e.target.value)}
          sx={{ mt: 1 }}
        />
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel>Controlado</InputLabel>
          <Select
            label="Controlado"
            value={formControlled}
            onChange={(e) => setFormControlled(e.target.value)}
          >
            <MenuItem value={false}>Não</MenuItem>
            <MenuItem value={true}>Sim</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={save} disabled={!formDescription.trim()}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

MedicineFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  medicine: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    dosage: PropTypes.string,
    controlled: PropTypes.bool,
  }),
};

MedicineFormModal.defaultProps = {
  medicine: null,
};
